const CSP_NONCE_META_SELECTOR = 'meta[name="csp-nonce"], meta[property="csp-nonce"]'
const CSP_NONCE_PLACEHOLDER = '__CSP_NONCE__'
const CSP_NONCE_SAFE_REGEX = /^[A-Za-z0-9_-]{1,256}$/
const CSP_NONCE_PATCHED_FLAG = '__minutes_csp_nonce_create_element_patched__'

declare global {
    interface Window {
        __webpack_nonce__?: string
    }
}

export const getCspNonce = (): string | undefined => {
    if (typeof document === 'undefined') {
        return undefined
    }

    const content = document.querySelector(CSP_NONCE_META_SELECTOR)?.getAttribute('content') || ''
    if (!content || content === CSP_NONCE_PLACEHOLDER) {
        return undefined
    }

    return content
}

const applyNonce = (element: Element, nonce: string): void => {
    const normalizedTag = element.tagName?.toLowerCase()
    if (
        (normalizedTag === 'style' || normalizedTag === 'script') &&
        !element.getAttribute('nonce')
    ) {
        element.setAttribute('nonce', nonce)
    }
}

export const setWebpackNonce = (nonce?: string): void => {
    if (!nonce || typeof window === 'undefined') {
        return
    }

    if (!CSP_NONCE_SAFE_REGEX.test(nonce)) {
        return
    }

    // Guardrails:
    // - Set once for this runtime bootstrap path.
    // - Do not overwrite if another runtime has already set a different value.
    if (!window.__webpack_nonce__) {
        window.__webpack_nonce__ = nonce
    }
}

export const applyCspNonceForDynamicElements = (nonce?: string): void => {
    if (!nonce || typeof document === 'undefined') {
        return
    }

    setWebpackNonce(nonce)

    const doc = document as Document & { [CSP_NONCE_PATCHED_FLAG]?: boolean }
    if (!doc[CSP_NONCE_PATCHED_FLAG]) {
        doc[CSP_NONCE_PATCHED_FLAG] = true
        const originalCreateElement = doc.createElement.bind(doc)

        doc.createElement = ((tagName: string, options?: ElementCreationOptions) => {
            const element = originalCreateElement(tagName, options as any)
            applyNonce(element, nonce)
            return element
        }) as typeof document.createElement
    }

    document.querySelectorAll('style,script').forEach((element) => applyNonce(element, nonce))
}
